/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  GET_CUSTOMERS: "/api/chat/customer/seller/getCustomers/",
  GET_SELLERS: "/api/chat/seller/admin/getSellers",
  GET_CUSTOMER_MESSAGES: "/api/chat/customer/seller/get_customer_messages/",
  SEND_MESSAGE_To_CUSTOMER:
    "/api/chat/customer/seller/send_message_to_Customer",
  ADMIN_MESSAGE_To_SELLER: "/api/chat/seller/admin/admin_message_to_Seller",
  SELLER_MESSAGE_TO_ADMIN: "/api/chat/admin/admin/seller_message_to_Admin",
  GET_ADMIN_MESSAGES: "/api/chat/seller/admin/get_admin_messages/",
  GET_SELLER_MESSAGES: "/api/chat/admin/seller/get_seller_messages",
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

export const getCustomers = createAsyncThunk(
  "chat/getCustomers",
  async (sellerId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.GET_CUSTOMERS + `${sellerId}`, {
        withCredentials: true,
      });
      //console.log("Info utilisateur friend :", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Erreur lors de d'ajout d'un ami : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
export const get_customer_messages = createAsyncThunk(
  "chat/get_customer_messages",
  async (customerID, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        API_ROUTES.GET_CUSTOMER_MESSAGES + `${customerID}`,
        { withCredentials: true },
      );
      //console.log("Info utilisateur friend :", data);
      return fulfillWithValue(data);
    } catch (error) {
      //console.error("Erreur lors de d'ajout d'un ami : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const send_message_to_Customer = createAsyncThunk(
  "chat/send_message_to_Customer",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        API_ROUTES.SEND_MESSAGE_To_CUSTOMER,
        info,
        { withCredentials: true },
      );
      //console.log("Info utilisateur message :", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Erreur lors de l'envoi d'un message : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

/*
export const send_message_to_Customer = createAsyncThunk(
  "chat/send_message_to_Customer",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      // ── Construire un FormData multipart ──────────────────────────────────
      const formData = new FormData();
      formData.append("customerId", info.customerId);
      formData.append("sellerId", info.sellerId);
      formData.append("senderName", info.senderName ?? "");
      formData.append("message", info.message ?? "");
      formData.append("messageType", info.messageType ?? "text");

      // Attacher le fichier image si présent (vrai File, pas base64)
      if (info.imageFile instanceof File) {
        formData.append("files", info.imageFile); // "files" = nom attendu par upload.array("files")
      }

      const { data } = await api.post(
        API_ROUTES.SEND_MESSAGE_To_CUSTOMER,
        formData,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" }, // laisser le browser gérer le boundary
        },
      );

      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
*/
export const admin_message_to_seller = createAsyncThunk(
  "chat/admin_message_to_seller",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        API_ROUTES.ADMIN_MESSAGE_To_SELLER,
        info,
        { withCredentials: true },
      );
      console.log("admin to seller message :", data);
      debugger;
      // await new Promise(resolve => setTimeout(resolve, 3000)); // Pause de 3 secondes
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de l'envoi d'un message : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const seller_message_to_admin = createAsyncThunk(
  "chat/seller_message_to_admin ",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        API_ROUTES.SELLER_MESSAGE_TO_ADMIN,
        info,
        { withCredentials: true },
      );
      //console.log("admin to seller message :", data);
      debugger;
      // await new Promise(resolve => setTimeout(resolve, 3000)); // Pause de 3 secondes
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de l'envoi d'un message : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const getSellers = createAsyncThunk(
  "chat/getSellers",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.GET_SELLERS, {
        withCredentials: true,
      });
      // console.log("get selleers  :", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Erreur lors de d'ajout d'un ami : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_admin_messages = createAsyncThunk(
  "chat/get_admin_messages",
  async (receiverId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        API_ROUTES.GET_ADMIN_MESSAGES + `${receiverId}`,
        { withCredentials: true },
      );
      // console.log("get selleers  :", data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Erreur lors de d'ajout d'un ami : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_seller_messages = createAsyncThunk(
  "chat/get_seller_messages ",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.GET_SELLER_MESSAGES, {
        withCredentials: true,
      });
      // console.log("get selleers  :", data);
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Erreur lors de d'ajout d'un ami : ", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Reducer principal
export const chatReducer = createSlice({
  name: "chat",
  initialState: {
    successMessage: "",
    messageError: "",
    loader: false,
    myFriends: [],
    messages: [],
    customers: [],
    sellers: [],
    activeCustomer: [],
    activeSeller: [],
    messageNotification: [],
    seller_admin_messages: [],
    adminSuccessMessage: "",
    adminMessageError: "",
    adminLoader: false,
    activeAdmin: "",
    currentSeller: {},
    currentCustomer: {},
    sellerLoader: false,
    sellerMessageError: "",
    sellerSuccessMessage: "",
    totalUnread: 0,
    unreadPerCustomer: [], // FIX : [] au lieu de {},
  },

  reducers: {
    setChatInfo: (state, action) => {
      state.chatInfo = action.payload;
    },

    messageClear: (state) => {
      state.messageError = "";
      state.successMessage = "";
      state.adminSuccessMessage = "";
      state.adminMessageError = "";
      state.sellerMessageError = "";
      state.sellerSuccessMessage = "";
    },

    updateMessage: (state, action) => {
      state.messages = [...state.messages, action.payload];
    },

    updateCustomer: (state, action) => {
      state.activeCustomer = action.payload;
    },

    updateSeller: (state, action) => {
      state.activeSeller = action.payload;
    },

    updateAdminMessage: (state, action) => {
      state.seller_admin_messages = [
        ...state.seller_admin_messages,
        action.payload,
      ];
    },

    update_activeStatus: (state, action) => {
      state.activeAdmin = action.payload.status;
    },

    // FIX : marque uniquement les messages RECUS du customer comme vus
    markMessagesAsSeen: (state, action) => {
      const { customerId } = action.payload;
      state.messages = state.messages.map((msg) =>
        msg.senderId === customerId ? { ...msg, seen: true } : msg,
      );
    },

    // FIX : guard Array.isArray + support objet/tableau
    clearUnreadForCustomer: (state, action) => {
      const customerId = action.payload;

      if (Array.isArray(state.unreadPerCustomer)) {
        state.unreadPerCustomer = state.unreadPerCustomer.map((u) =>
          u._id === customerId ? { ...u, count: 0 } : u,
        );
        state.totalUnread = state.unreadPerCustomer.reduce(
          (acc, u) => acc + (u.count || 0),
          0,
        );
      } else if (typeof state.unreadPerCustomer === "object") {
        const prev = state.unreadPerCustomer[customerId] || 0;
        state.unreadPerCustomer[customerId] = 0;
        state.totalUnread = Math.max(0, state.totalUnread - prev);
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCustomers.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(getCustomers.fulfilled, (state, action) => {
        state.loader = false;
        state.myFriends = action.payload;
        state.customers = action.payload.customers;
        state.totalUnread = action.payload.totalUnread;
        state.unreadPerCustomer = action.payload.unreadPerCustomer;
      })
      .addCase(getCustomers.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload;
      })
      .addCase(get_customer_messages.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(get_customer_messages.fulfilled, (state, action) => {
        state.loader = false;
        state.messages = action.payload.messages;
        state.currentCustomer = action.payload.currentCustomer;
        state.successMessage = "";
      })
      .addCase(send_message_to_Customer.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })

      .addCase(send_message_to_Customer.fulfilled, (state, action) => {
        const myMessage = action.payload?.data;

        if (myMessage?.receiverId) {
          // ✅ sécurisation
          let tempFriends = Array.isArray(state.myFriends)
            ? [...state.myFriends]
            : [];

          const friendIndex = tempFriends.findIndex(
            (friend) => friend.fdId === myMessage.receiverId,
          );

          // ✅ remonter le friend en haut
          if (friendIndex > -1) {
            const [friend] = tempFriends.splice(friendIndex, 1);
            tempFriends.unshift(friend);
          }

          state.myFriends = tempFriends;

          state.messages.push(myMessage);

          state.successMessage =
            action.payload.message || "Message sent successfully";
        } else {
          console.warn("Invalid payload:", action.payload);
        }

        state.loader = false;
      })
      /*
      .addCase(send_message_to_Customer.fulfilled, (state, action) => {
        const myMessage = action.payload.data; // Les données sont sous `data`
        if (myMessage?.receiverId) {
          let tempFriends = state.myFriends;
          let friendIndex = tempFriends.findIndex(
            (friend) => friend.fdId === myMessage.receiverId,
          );

          while (friendIndex > 0) {
            let friend = tempFriends[friendIndex];
            tempFriends[friendIndex] = tempFriends[friendIndex - 1];
            tempFriends[friendIndex - 1] = friend;
            friendIndex--;
          }

          state.messages = [...state.messages, myMessage];
          state.successMessage =
            action.payload.message || "Message sent successfully";
        } else {
          console.warn("Invalid payload or myMessage:", action.payload);
        }

        state.loader = false;
      })
*/
      .addCase(send_message_to_Customer.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload;
      })

      .addCase(admin_message_to_seller.pending, (state) => {
        state.adminLoader = true;
        state.adminMessageError = "";
      })
      .addCase(admin_message_to_seller.rejected, (state, action) => {
        state.adminLoader = false;
        state.adminMessageError = action.payload;
      })
      .addCase(admin_message_to_seller.fulfilled, (state, action) => {
        // console.log(' admin_message_to_seller.fulfilled', action.payload);
        const myMessage = action.payload.admin_Message;
        state.adminLoader = false;
        state.adminSuccessMessage =
          action.payload.message || "Message sent successfully";

        state.seller_admin_messages = [
          ...state.seller_admin_messages,
          myMessage,
        ];
      })

      .addCase(seller_message_to_admin.pending, (state) => {
        state.sellerLoader = true;
        state.sellerMessageError = "";
      })
      .addCase(seller_message_to_admin.rejected, (state, action) => {
        state.sellerLoader = false;
        state.sellerMessageError = action.payload;
      })
      .addCase(seller_message_to_admin.fulfilled, (state, action) => {
        // console.log(' seller_message_to_admin  fulfilled', action.payload);
        const myMessage = action.payload.seller_Message;
        state.sellerLoader = false;
        state.sellerSuccessMessage =
          action.payload.message || "Message sent successfully";
        state.seller_admin_messages = [
          ...state.seller_admin_messages,
          myMessage,
        ];
      })

      .addCase(getSellers.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload;
      })
      .addCase(getSellers.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(getSellers.fulfilled, (state, action) => {
        state.loader = false;
        state.sellers = action.payload.sellers || [];
        state.successMessage = "";
      })
      .addCase(get_admin_messages.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload;
      })
      .addCase(get_admin_messages.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(get_admin_messages.fulfilled, (state, action) => {
        state.loader = false;
        state.seller_admin_messages = action.payload.messages || [];
        state.currentSeller = action.payload.currentSeller || {};
        state.successMessage =
          action.payload.message || "Message sent successfully";
      })
      .addCase(get_seller_messages.rejected, (state, action) => {
        state.loader = false;
        state.messageError = action.payload;
      })
      .addCase(get_seller_messages.pending, (state) => {
        state.loader = true;
        state.messageError = "";
      })
      .addCase(get_seller_messages.fulfilled, (state, action) => {
        state.loader = false;
        state.seller_admin_messages = action.payload.messages || [];
        state.successMessage =
          action.payload.message || "Message sent successfully";
      });
  },
});

export const {
  setChatInfo,
  messageClear,
  updateMessage,
  updateCustomer,
  updateSeller,
  updateAdminMessage,
  update_activeStatus,
  markMessagesAsSeen,
  clearUnreadForCustomer,
} = chatReducer.actions;
export default chatReducer.reducer;
